import { createContext } from "preact";
import { useContext } from "preact/hooks";
import type { WalletSessionValue } from "@tenergy/web-core/wallet";

/** The panel's one wallet controller, for the parts that sign far from the app root (the Nile sign-in). */
export const AdminWalletContext = createContext<WalletSessionValue | null>(null);

export function useAdminWallet(): WalletSessionValue {
  const wallet = useContext(AdminWalletContext);
  if (wallet === null) throw new Error("AdminWalletContext is missing above this component");
  return wallet;
}
